import React from "react";
import styles from "./StandardPeopleTagList.module.scss";

interface StandardPeopleTagListProps {
  list: any[];
}

// 定义标签组件
const StandardPeopleTag = ({ label,item }: any) => {
    const handleDragStart = (event: React.DragEvent<HTMLDivElement>, label: any) => {
        event.dataTransfer.setData('application/json', JSON.stringify(label));
    };

    return (
        <div
        className={styles["standardPeopleTag"]}
            draggable="true"
            onDragStart={(event) => handleDragStart(event, label)}
        >
            <div className={styles["labelName"]}>{label.label_name}</div>
            <div className={styles["labelDesc"]}>{label.label_desc}</div>
        </div>
    );
};

const StandardPeopleTagList: React.FC<StandardPeopleTagListProps> = ({ list = [] }) => {
  return (
    <div className={styles["standardPeopleTagList"]}>
      {list.map((item: any,index:number) => (
        <div key={index} style={{ color: "#bcbdc0", fontSize: "12px", lineHeight: "16px" }}>
          <div>{item.tab_name}</div>
          {item.label_list.map((label: any,i:number) => {
            return <StandardPeopleTag key={i} label={label} item={item} />;
          })}
        </div>

        // <span key={item.id} className="bg-gray-300 text-xs px-2 py-1 rounded">{item.tab_name}</span>
      ))}
    </div>
  );
};

export default StandardPeopleTagList;
